import { adapter } from '@seek/tealium-adapter';
import {
  Box,
  ContentBlock,
  Disclosure,
  Stack,
  Heading,
} from 'braid-design-system';
import React, { useState } from 'react';

import { MoneyBackPromise } from './TermsAndConditionsSections';

const tealium = adapter();

const RefundGuarantee = () => {
  const [isOpen, toggleOpen] = useState(false);
  const accordionTrackingProps = {
    siteSection: 'products',
    currentPage: 'guaranteed-hire',
    linkName: 'read-terms-and-conditions',
    eventName: 'read-terms-and-conditions',
  };

  const accordionOnChange = () => {
    const action = isOpen ? 'collapsed' : 'expanded';
    tealium.link(accordionTrackingProps.linkName, {
      ...accordionTrackingProps,
      action,
    });
    toggleOpen((state) => !state);
  };

  return (
    <Box background="brand" padding="gutter" paddingY="xlarge">
      <ContentBlock>
        <Stack space="large" align="center">
          <Heading level="2">
            If you don’t make a placement, you get a full refund
          </Heading>
          <Box textAlign="center">
            <Disclosure
              id="refund-terms"
              expandLabel="Read our Terms and Conditions"
              expanded={isOpen}
              onToggle={() => accordionOnChange()}
            >
              <Box paddingTop="xlarge" textAlign="left">
                <Stack space="xlarge">
                  <MoneyBackPromise />
                </Stack>
              </Box>
            </Disclosure>
          </Box>
        </Stack>
      </ContentBlock>
    </Box>
  );
};

export default RefundGuarantee;
